import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";

export default class PlanificadorRuta {

    // PlanificadorRuta.getPRD() <- asi se usa
    static async getPRD(): Promise<RequestResponse> {

        return new Request(MICROSERVICIOS.PLANIFICADOR_RUTA_PRD).getPlanificadorRutaPRD('Ping'  );
    }

       // PlanificadorRuta.getQA() <- asi se usa
       static async getQA(): Promise<RequestResponse> {

        return new Request(MICROSERVICIOS.PLANIFICADOR_RUTA_QA).getPlanificadorRutaQA('Ping');
    }


       // PlanificadorRuta.getPingDbPRD() <- asi se usa
    static async getPingDbPRD(): Promise<RequestResponse> {
      
        return new Request(MICROSERVICIOS.PLANIFICADOR_RUTA_PRD).getPlanificadorRutaPRD('PingOracle' );
    }

       // PlanificadorRuta.getPingDbQA() <- asi se usa
       static async getPingDbQA(): Promise<RequestResponse> {
   

        return new Request(MICROSERVICIOS.PLANIFICADOR_RUTA_QA).getPlanificadorRutaQA('PingOracle' );
    }


}